// 前后端通信协议（自家 API，非 Ulucu 直传）。
// 单 upstream 模式：仅走开放平台。见 docs/05-decisions.md ADR-011。
export const RTL_LOCALES = ['ar-SA'];
export const isRTL = (locale) => RTL_LOCALES.includes(locale);
//# sourceMappingURL=protocol.js.map